import React, { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Container,
  Alert
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client/react';
import { SIGN_IN_MUTATION } from './mutations';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [signInUser, { loading }] = useMutation(SIGN_IN_MUTATION);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const { data } = await signInUser({
        variables: { email, password }
      });

      if (data?.signInUser?.token) {
        if (typeof window !== 'undefined') {
          localStorage.setItem('token', data.signInUser.token);
          localStorage.setItem('refresh_token', data.signInUser.refresh_token);
          localStorage.setItem('isAuthenticated', 'true');
        }
        navigate('/dashboard');
      } else if (data?.signInUser?.errors) {
        setError(data.signInUser.errors);
      }
    } catch (err) {
      setError('Login error');
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Card sx={{ width: '100%', mt: 3 }}>
          <CardContent sx={{ p: 4 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
              <img
                src="/dark_logo_transparent.png"
                alt="weldinGo"
                style={{ height: '40px', marginRight: '8px' }}
              />
              <Typography variant="h4" component="span" sx={{ fontWeight: 'bold' }}>
                PROJECTS
              </Typography>
            </Box>
            <Typography component="h1" variant="h5" align="center" gutterBottom>
              Sign In
            </Typography>

            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}

            <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email"
                name="email"
                autoComplete="email"
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                disabled={loading}
              >
                {loading ? 'Signing in...' : 'Sign In'}
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default Login;
